import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomer } from "../context/CustomerContext";
import WishlistProductGrid from "../components/WishlistProductGrid";
import styles from "./GuestWishlist.module.css";

const GuestWishlist = () => {
  const { customer, loading } = useCustomer();

  if (loading) {
    return (
      <>
        <h1 className={styles.pageTitle}>Обрані товари</h1>
        <div className={styles.emptyWishlist}>Завантаження...</div>
      </>
    );
  }

  if (customer) {
    return <Navigate to="/cabinet/wishlist" replace />;
  }

  return (
    <>
      <h1 className={styles.pageTitle}>Обрані товари</h1>
      <WishlistProductGrid
        cardStyles={styles}
        sectionClassName={styles.wishlistSection}
        emptyClassName={styles.emptyWishlist}
      />
    </>
  );
};

export default GuestWishlist;
